import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { routes } from './app.routes';
import { authInterceptor } from './guards/auth.interceptor';
import { es } from 'primelocale/es.json';
import { HttpErrorInterceptor } from './shared/interceptor/http-error.interceptor';


/**
 * Brand primary (VELO lime). This preset is the single source of truth for the
 * primary color: PrimeNG emits it as `--arc-primary-*` / `--arc-primary-color`,
 * and the legacy app variables in `src/styles.scss` point to those tokens.
 * Text on the lime surface must be dark (`#171717`) to meet contrast.
 */
const PRIMARY_CONTRAST = '#171717';

const customAura = {
  ...Aura,
  semantic: {
    ...Aura.semantic,
    primary: {
      ...Aura.semantic?.primary,
      50: '#f8ffe5',
      100: '#efffc4',
      200: '#ddfe8f',
      300: '#c9fd52',
      400: '#bafb22',
      500: '#adf902', // Brand lime
      600: '#8bc800',
      700: '#699700',
      800: '#527608',
      900: '#45620c',
      950: '#233700',
    },
    colorScheme: {
      ...Aura.semantic?.colorScheme,
      light: {
        ...Aura.semantic?.colorScheme?.light,
        primary: {
          ...Aura.semantic?.colorScheme?.light?.primary,
          contrastColor: PRIMARY_CONTRAST,
        },
      },
    },
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: es,
      theme: {
        preset: customAura,
        options: {
          prefix: 'arc',
          darkModeSelector: '.my-app-dark', 
          scope: 'primeng',
        },
      },
    }),
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
  ],
};